import { useStore, useStoreMap } from 'effector-react'
import { Form } from '~/entities/common/Taxipark/Employee'
import { $user, fetchUserFx } from '~/entities/common/viewer/model'
import { Region, Role } from '~/shared/api'
import { localeEnumLabels, timezoneCodeLabels } from '~/shared/config/constants'

export function PersonalData() {
  const defaultValues = useStoreMap($user, (user) => {
    const timezone = user?.getTimezone()
    const locale = user?.getLocale()

    return {
      ...user?.getAttributes(),
      rolesIds: user?.getRoles()?.map((role: Role) => role.getOption()),
      regionsIds: user
        ?.getRegions()
        ?.map((region: Region) => region.getOption()),
      timezone: timezone
        ? {
            id: timezone,
            label: timezoneCodeLabels[timezone],
          }
        : null,
      locale: locale
        ? {
            id: locale,
            label: localeEnumLabels[locale],
          }
        : null,
    }
  })
  const isFetchUserPending = useStore(fetchUserFx.pending)

  return (
    <Form
      isLoading={isFetchUserPending}
      defaultValues={defaultValues}
      canEdit={false}
    />
  )
}
